import type { ReactNode } from "react";
import { DatasetFilter } from "./DatasetFilter";
import { DatasetFilterAdvancedButton } from "./DatasetFilterAdvancedButton";
import type { DatasetFilterController } from "./DatasetFilterController";
import type { DatasetFilterSurface } from "./datasetFilterBookmarks";
import { DatasetSearchInput } from "./DatasetSearchInput";
import styles from "./DatasetFilterBlock.module.css";

export type DatasetFilterBlockProps = {
  controller: DatasetFilterController;
  bookmarkSurface: DatasetFilterSurface;
  bookmarkUid: string | null;
  searchPlaceholder?: string;
  searchAriaLabel?: string;
};

/**
 * 데이터셋 조건 블록이다. 검색 행(콤보박스 + ⚙ 고급 필터)과 필터 레일(프리셋·facet·적용 조건 칩)을 담는다.
 *
 * Datasets 와 Review 가 같은 블록을 페이지 헤더의 belowTabs 슬롯에 둔다. 두 화면의 검색 폭·
 * 버튼 위치·칩 행이 같아야 한다(rules.md §17). 이 컴포넌트 하나가 그 규약을 보장한다. 결과 수는
 * 여기 없다. 목록 상단 BulkActionBar 가 소유한다.
 */
export function DatasetFilterBlock({
  controller,
  bookmarkSurface,
  bookmarkUid,
  searchPlaceholder,
  searchAriaLabel,
}: DatasetFilterBlockProps): ReactNode {
  return (
    <div className={styles.block}>
      <div className={styles.row}>
        <DatasetSearchInput
          controller={controller}
          className={styles.search}
          placeholder={searchPlaceholder}
          ariaLabel={searchAriaLabel}
        />
        <DatasetFilterAdvancedButton controller={controller} />
      </div>
      <DatasetFilter
        controller={controller}
        bookmarkSurface={bookmarkSurface}
        bookmarkUid={bookmarkUid}
      />
    </div>
  );
}
